import { render, staticRenderFns } from "./Thecopyright.vue?vue&type=template&id=cd0c94f0"
import script from "./Thecopyright.vue?vue&type=script&lang=js"
export * from "./Thecopyright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports